---
meta:
  - title: Personalizar el asistente - IUSPRO Docs
  - description: Aprende a personalizar Auri para obtener respuestas más relevantes.
---

# Personalizar el asistente

<a href="/settings/personalizacion" target="_blank">
	Ir a Personalización →
</a>

La personalización permite que Auri te brinde respuestas más relevantes y adaptadas a tu contexto profesional.

## Cómo acceder

1. Haz clic en tu **nombre o email** en la esquina inferior izquierda
2. Selecciona **"Preferencias"**
3. Ve a la pestaña **"Personalización"**

## Opciones de personalización

**¿Cómo quieres que Ius Pro te llame?**

- Puedes usar tu nombre, título profesional o como prefieras
- Ejemplos: "María", "Dr. García", "Licenciado Pérez"

**¿Algo que Ius Pro debería saber sobre ti?**

- Describe tu especialidad o área de práctica
- Indica tu estilo de comunicación preferido
- Menciona tus intereses profesionales específicos
- Especifica el nivel de detalle que prefieres en las respuestas

## Guardar cambios

Una vez completados los campos, haz clic en **"Guardar Personalización"** para aplicar los cambios.

## Beneficios

- **Respuestas más relevantes** adaptadas a tu especialidad
- **Tono y estilo ajustados** a tus preferencias
- **Mejor comprensión** de tu contexto profesional
